import { PaymentMethods } from '@features/payment'

export default function PaymentPage () {
  return (
    <div>
      <PaymentMethods />
    </div>
  )
}
